module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.$route.meta.isLogin == true) ? _c('div', {
    staticClass: "bgfixed"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-res-box",
    class: _vm.isLimitOut ? 'achieve-limit' : '',
    style: (_vm.$route.meta.isLogin == true ? 'margin-top:13%;' : '')
  }, [(_vm.$route.meta.isLogin == true) ? _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": this.channelLogo
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dialogTyper != -1) ? _c('i', {
    staticClass: "iconfont icon-del custom-layout",
    on: {
      "click": _vm.closeLoginBox
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', [(_vm.isLimitOut) ? _c('el-col', {
    staticClass: "limit-out",
    attrs: {
      "span": 13
    }
  }, [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('D306')) + "，")]), _vm._v(" "), _c('p', {
    staticClass: "p-1"
  }, [_vm._v(_vm._s(_vm.$t(_vm.searchTip)))])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center img",
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/svg/limit_out.svg")
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "text-left",
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('D307')) + "：")])]), _vm._v(" "), _c('el-col', {
    staticClass: "benefit",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('PERSON_SEARCH')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('D308')) + " "), _c('span', {
    staticClass: "bigger"
  }, [_vm._v("10")]), _vm._v(" " + _vm._s(_vm.$t('D309')) + " "), _c('img', {
    attrs: {
      "src": require("../assets/svg/up.svg")
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('D311')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('D308')) + " "), _c('span', {
    staticClass: "bigger"
  }, [_vm._v("5")]), _vm._v(" " + _vm._s(_vm.$t('D309')) + " "), _c('img', {
    attrs: {
      "src": require("../assets/svg/up.svg")
    }
  })])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.isLimitOut ? 11 : 24
    }
  }, [_c('div', {
    staticClass: "login-head"
  }, [_c('div', {
    staticClass: "wrap_1"
  }, [(_vm.login_form.dialogType == 1 || _vm.login_form.dialogType == 2) ? _c('div', {
    ref: "headItem2",
    staticClass: "item item_1",
    class: _vm.login_form.dialogType == 1 ? 'active' : '',
    style: ({
      'color': _vm.login_form.dialogType == 1 ? _vm.channelColor : '',
      'border-bottom': _vm.login_form.dialogType == 1 ? '2px solid ' + _vm.channelColor : '',
      'margin-left': '0'
    }),
    on: {
      "mouseenter": function($event) {
        _vm.$refs.headItem2.style.color = _vm.channelColor
      },
      "mouseleave": function($event) {
        _vm.$refs.headItem2.style.color = (_vm.login_form.dialogType == 1 ? _vm.channelColor : '#666666')
      },
      "click": function($event) {
        _vm.changeType(1)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('L008')) + "\n                            ")]) : _vm._e()]), _vm._v(" "), (_vm.login_form.dialogType == 3) ? _c('div', {
    staticClass: "item item_2"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('L001')) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.login_form.dialogType == 4) ? _c('div', {
    staticClass: "item item_2"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('D348')) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (_vm.login_form.dialogType == 1) ? _c('div', [_c('el-row', {
    staticClass: "phone-email"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": this.$t('D142')
    },
    model: {
      value: (_vm.login_form.user_name),
      callback: function($$v) {
        _vm.$set(_vm.login_form, "user_name", $$v)
      },
      expression: "login_form.user_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pwd"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": this.$t('SEARCH_SENTENSE6')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginSubmit($event)
      }
    },
    model: {
      value: (_vm.login_form.password),
      callback: function($$v) {
        _vm.$set(_vm.login_form, "password", $$v)
      },
      expression: "login_form.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "login-cookie",
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.login_form.maintainLogin),
      callback: function($$v) {
        _vm.$set(_vm.login_form, "maintainLogin", $$v)
      },
      expression: "login_form.maintainLogin"
    }
  }, [_vm._v(_vm._s(_vm.$t('D391')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "btn-cus"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "custom-btn",
    style: ({
      'background': _vm.channelColor,
      'border-color': _vm.channelColor
    }),
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.login_form.btnLoading
    },
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('LOGIN')) + "\n                                ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "line-bom"
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "line-blk"
  }, [(_vm.showLogin) ? _c('span', {
    ref: "regis",
    staticClass: "reg",
    style: ({
      color: _vm.channelColor
    }),
    on: {
      "click": function($event) {
        _vm.changeType(3)
      },
      "mouseenter": function($event) {
        _vm.$refs.regis.style.color = _vm.channelColor
      },
      "mouseleave": function($event) {
        _vm.$refs.regis.style.color = _vm.channelColor
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('L018')))]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "forpwd",
    staticClass: "fg-pwd",
    staticStyle: {
      "float": "right"
    },
    style: (!_vm.showLogin ? 'margin-left:0;' : ''),
    on: {
      "mouseenter": function($event) {
        _vm.$refs.forpwd.style.color = _vm.channelColor
      },
      "mouseleave": function($event) {
        _vm.$refs.forpwd.style.color = '#666666'
      },
      "click": function($event) {
        _vm.$router.push({
          path: '/forgotPassword'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('SETTING_FORGET')) + "？")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.login_form.dialogType == 3) ? _c('div', [_c('el-row', {
    staticClass: "phone-email"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "master-input"
  }, [_c('div', {
    staticClass: "prepend"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.handleCmd
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                                " + _vm._s(_vm.regNames[_vm.login_form.nameType]) + " "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), (_vm.formParams && _vm.formParams.registerEmail) ? _c('el-dropdown-menu', {
    staticClass: "master-input-item",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": "",
      "command": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('EMAIL_ADDRESS')) + "\n                                                ")])], 1) : _c('el-dropdown-menu', {
    staticClass: "master-input-item",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('EMAIL_ADDRESS')) + "\n                                            ")])], 1)], 1)], 1), _vm._v(" "), (_vm.formParams && _vm.formParams.registerEmail) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_form.user_name = _vm.formParams.registerEmail),
      expression: "login_form.user_name = formParams.registerEmail"
    }],
    staticClass: "p-left",
    attrs: {
      "placeholder": _vm.regPlaceHolder[_vm.login_form.nameType],
      "disabled": ""
    },
    domProps: {
      "value": (_vm.login_form.user_name = _vm.formParams.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login_form.user_name = _vm.formParams, "registerEmail", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_form.user_name),
      expression: "login_form.user_name"
    }],
    staticClass: "p-left",
    attrs: {
      "placeholder": _vm.regPlaceHolder[_vm.login_form.nameType]
    },
    domProps: {
      "value": (_vm.login_form.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login_form, "user_name", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "handle"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hovering || _vm.dragging),
      expression: "hovering||dragging"
    }],
    staticClass: "imgBox"
  }, [_c('img', {
    staticClass: "verImg",
    attrs: {
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verify),
      expression: "verify"
    }],
    staticClass: "verify"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verified),
      expression: "verified"
    }],
    staticClass: "verified"
  }), _vm._v("\n                                            <!– "), _c('div', {
    staticClass: "refreshBox"
  }, [_c('span', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshImg()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])]), _vm._v("–>\n                                        ")])]), _vm._v(" "), _c('span', {
    staticClass: "swiper",
    class: _vm.wrapperStyle,
    on: {
      "mouseenter": _vm.handleMouseEnter,
      "mouseleave": _vm.handleMouseLeave,
      "mousedown": _vm.onButtonDown,
      "touchstart": _vm.onButtonDown
    }
  }, [(!this.login_form.identifyCode) ? _c('i', {
    staticClass: "fa fa-angle-double-right"
  }) : _vm._e(), _vm._v(" "), (this.login_form.identifyCode) ? _c('i', {
    staticClass: "fa fa-check-circle-o",
    style: ({
      'color': _vm.channelColor
    })
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('L011')))])], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "validation-code"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "master-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_form.identify),
      expression: "login_form.identify"
    }],
    staticClass: "p-right",
    attrs: {
      "placeholder": this.$t('SEARCH_SENTENSE10')
    },
    domProps: {
      "value": (_vm.login_form.identify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login_form, "identify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.login_form.codeLoading),
      expression: "login_form.codeLoading"
    }],
    staticClass: "append"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    style: ({
      'color': _vm.channelColor
    }),
    on: {
      "click": _vm.send_code
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('D145')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._v(_vm._s(_vm.count) + " s")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pwd-register"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": this.$t('SEARCH_SENTENSE6')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.registerSubmit($event)
      }
    },
    model: {
      value: (_vm.login_form.password),
      callback: function($$v) {
        _vm.$set(_vm.login_form, "password", $$v)
      },
      expression: "login_form.password"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('el-row', [_c('el-col', {
    staticClass: "login-cookie",
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.login_form.allowProtocol),
      callback: function($$v) {
        _vm.$set(_vm.login_form, "allowProtocol", $$v)
      },
      expression: "login_form.allowProtocol"
    }
  }, [_vm._v(_vm._s(_vm.$t('L005')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "btn-cus"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "custom-btn",
    style: ({
      'background': _vm.channelColor,
      'border-color': _vm.channelColor
    }),
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.register_loding
    },
    on: {
      "click": _vm.registerSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('L006')) + "\n                                ")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "line-bom"
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "line-blk"
  }, [_c('span', {
    ref: "bk_login",
    staticClass: "reg",
    on: {
      "mouseenter": function($event) {
        _vm.$refs.bk_login.style.color = _vm.channelColor
      },
      "mouseleave": function($event) {
        _vm.$refs.bk_login.style.color = '#666666'
      },
      "click": function($event) {
        _vm.changeType(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('L007')))])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.login_form.dialogType == 4) ? _c('div', [_c('el-row', {
    staticClass: "phone-email"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "master-input"
  }, [_c('div', {
    staticClass: "prepend"
  }, [_c('div', {
    staticClass: "el-dropdown"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                                           " + _vm._s(_vm.regNames[_vm.login_form.nameType]) + "\n                                        ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_form.user_name),
      expression: "login_form.user_name"
    }],
    staticClass: "p-left",
    attrs: {
      "placeholder": _vm.regPlaceHolder[_vm.login_form.nameType]
    },
    domProps: {
      "value": (_vm.login_form.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login_form, "user_name", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "btn-cus"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "custom-btn",
    style: ({
      'background': _vm.channelColor,
      'border-color': _vm.channelColor
    }),
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.login_form.btnLoading
    },
    on: {
      "click": _vm.bindSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('D256')) + "\n                                ")])], 1)], 1)], 1) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b68281da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 623
// module chunks = 39